export default {
  title: 'Adres dostawy',
  buttons: {
    save: 'Zapisz',
  },
};
